var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DASH") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DASH"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1",
    fill: "#157DD1",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    rx: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1980365,19.6309639 C47.3239885,20.4702656 47.2190383,21.3322031 46.9042466,22.1034069 L43.4413605,33.8760122 C43.1265687,34.6926146 42.7488303,35.4638184 42.2870847,36.2123865 C41.7414495,36.9609546 41.111866,37.6414249 40.419277,38.2311615 C39.7056862,38.8662967 38.866261,39.3199647 38.1316685,39.7736327 C37.3984877,40.066816 36.6256566,40.2277458 35.8441187,40.25 L9.61050931,40.25 L11.478317,34.193548 L35.1305868,34.193548 L38.866261,21.8085704 L15.2139913,21.8085704 L17.081799,15.7521184 L43.1895153,15.7521184 C43.8821043,15.7294827 44.5746932,15.8882506 45.2042768,16.2284857 C45.8129174,16.4779872 46.3375508,16.9770538 46.6313996,17.612189 C46.9671931,18.2246249 47.1560917,18.9277944 47.1980365,19.6309639 Z M24.532181,25.1883493 L22.8112683,30.7910697 L8.75,30.7910697 L10.6178665,25.1883493 L24.532181,25.1883493 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img-4.f94576bb644be3a1c252812882c3276e.svg";
export { ForwardRef as ReactComponent };